import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, X } from "lucide-react";

const KEY = "fount_preview_banner_dismissed";

export default function PreviewBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  // Only show in preview mode (billing disabled) and only when not dismissed.
  if (!user || user.billing_enabled || dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch (err) {
      console.warn("Could not persist banner dismissal.", err);
    }
    setDismissed(true);
  };

  return (
    <div
      data-testid="preview-banner"
      className="relative border-b border-[var(--border)] bg-white"
    >
      <div className="absolute inset-0 bg-brand-soft pointer-events-none" aria-hidden="true" />
      <div className="relative px-6 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 text-sm text-gray-800">
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-md bg-brand-gradient text-white">
            <Sparkles size={12} strokeWidth={2} />
          </span>
          <span>
            <span className="font-semibold">Fount is free during early access</span>
            <span className="text-gray-600"> — plans launch later this year. Until then, everything&apos;s unlocked.</span>
          </span>
        </div>
        <button
          data-testid="preview-banner-dismiss"
          onClick={dismiss}
          className="text-gray-500 hover:text-black p-1"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
